import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "met_cookie_consent";

export const getCookieConsent = () => {
    try { return localStorage.getItem(KEY); } catch { return null; }
};

export const CookieConsent = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (getCookieConsent()) return;
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
    }, []);

    const choose = (value) => {
        try { localStorage.setItem(KEY, value); } catch { /* private mode */ }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            role="dialog"
            aria-label="Cookie consent"
            className="fixed bottom-0 inset-x-0 z-[70] bg-primary/95 backdrop-blur-md text-primary-foreground border-t border-primary-foreground/15 shadow-2xl animate-in slide-in-from-bottom duration-500"
        >
            <div className="container-page py-5 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
                <div className="flex items-start gap-3 flex-1">
                    <Cookie size={18} strokeWidth={1.5} className="text-accent mt-0.5 shrink-0" />
                    <p className="text-xs leading-relaxed text-primary-foreground/85 max-w-3xl">
                        We use cookies and similar technologies to run this site, remember your preferences,
                        measure visits and improve your experience. Analytics and marketing cookies are set only
                        with your consent. See our{" "}
                        <Link to="/legal/privacy" className="underline underline-offset-2 text-accent hover:text-primary-foreground">
                            Privacy Policy
                        </Link>{" "}
                        for details.
                    </p>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                    <button
                        type="button"
                        onClick={() => choose("essential")}
                        data-testid="cookie-decline-btn"
                        className="px-5 py-3 border border-primary-foreground/40 text-[10px] tracking-[0.25em] uppercase font-semibold hover:border-accent hover:text-accent transition-colors"
                    >
                        Essential only
                    </button>
                    <button
                        type="button"
                        onClick={() => choose("accepted")}
                        data-testid="cookie-accept-btn"
                        className="px-6 py-3 bg-accent text-primary text-[10px] tracking-[0.25em] uppercase font-semibold hover:bg-primary-foreground transition-colors"
                    >
                        Accept all
                    </button>
                </div>
            </div>
        </div>
    );
};
